import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import findContainer from 'functions/digitalTemplate'
import { digObject } from 'functions/utilities'

import ReviewsWrapper from 'agency/digital_renderer/components/ReviewsWrapper'
import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const filterReviews = (reviews, filters, selectedReviewIds) => {
  const { limit, offset } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const filteredReviews = selectedReviewIds.length
    ? reviews.filter(review => selectedReviewIds.includes(review.id))
    : reviews

  const limited = filterLimit ? filteredReviews.slice(filterOffset, filterLimit) : filteredReviews.slice(filterOffset)

  return limited
}

const renderReviews = (container, campaigns, reviews) => reviews.map((review) => {
  const campaign = campaigns[review.campaign] || {}
  const reviewAddress = digObject(review, 'data.address', {})

  const reviewContext = {
    ...campaign,
    ...review,
    ...reviewAddress,
  }

  return (
    <div key={review.id} style={deviceStyle(container)}>
      <ElementContainer
        forwardContextToItems={reviewContext}
        section={container}
        renderNested
        render={({ itemComponents }) => itemComponents.map(component => component)}
      />
    </div>
  )
})

const Reviews = (props) => {
  const {
    callbacks: { registerActiveComponent },
    data,
    items,
    options,
  } = props

  const { shortcode } = data || {}

  const { agentIndex, limit, offset } = options

  const container = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const {
    activeComponents, agents, campaign, dataSource,
  } = defaultContext

  const selectedReviewIds = digObject(dataSource, 'options.review_ids', [])

  const agentIds = campaign.agents || []
  const agentId = agentIds[agentIndex]
  const agent = agents[agentId]

  if (!agent) return null

  return (
    <ReviewsWrapper
      agent={agent}
      render={({ campaigns, reviews }) => {
        const filtered = filterReviews(reviews, { limit, offset }, selectedReviewIds)
        if (!filtered.length) return null

        if (shortcode && !activeComponents[shortcode]){
          registerActiveComponent(shortcode, { count: filtered.length })
        }

        return (
          <AnimationWrapper options={options}>
            <div style={style}>{renderReviews(container, campaigns, filtered)}</div>
          </AnimationWrapper>
        )
      }}
    />
  )
}

Reviews.propTypes = {
  callbacks: PropTypes.shape({
    registerActiveComponent: PropTypes.func.isRequired,
  }),
  data: PropTypes.object,
  items: PropTypes.array,
  options: PropTypes.object,
}

Reviews.defaultProps = {
  items: [],
  options: {},
}

export default Reviews
